(function(){
  function init(container){
    if (!container) return;
    var track = container.querySelector('.fast-media-track');
    var slides = container.querySelectorAll('.fast-slide');
    var thumbs = container.querySelectorAll('.fast-media-thumb');
    if (!slides.length) return;
    var prevBtn = container.querySelector('.fast-media-prev');
    var nextBtn = container.querySelector('.fast-media-next');

    function switchTo(button){
      container.querySelectorAll('.fast-media-thumb.is-active').forEach(function(el){ el.classList.remove('is-active'); });
      button.classList.add('is-active');
      var idx = parseInt(button.getAttribute('data-media-index'), 10) || 0;
      var target = slides[idx];
      if (target){
        target.scrollIntoView({behavior: 'smooth', inline: 'center'});
      }
    }

    thumbs.forEach(function(btn){
      btn.addEventListener('click', function(){ switchTo(btn); });
      btn.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); switchTo(btn); }});
    });

    function getActiveIndex(){
      var active = container.querySelector('.fast-media-thumb.is-active');
      if (!active) return 0;
      return parseInt(active.getAttribute('data-media-index'), 10) || 0;
    }
    function go(delta){
      var idx = getActiveIndex();
      var next = idx + delta;
      if (next < 0) next = thumbs.length - 1;
      if (next >= thumbs.length) next = 0;
      if (thumbs[next]) switchTo(thumbs[next]);
    }
    if (prevBtn) prevBtn.addEventListener('click', function(){ go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ go(1); });

    // Sync active thumb on scroll
    var ticking = false;
    function onScroll(){
      if (ticking) return; ticking = true;
      requestAnimationFrame(function(){
        var viewCenter = track.scrollLeft + track.clientWidth / 2;
        var activeIdx = 0; var minDist = Infinity;
        slides.forEach(function(slide, i){
          var center = slide.offsetLeft + slide.clientWidth / 2;
          var dist = Math.abs(center - viewCenter);
          if (dist < minDist){ minDist = dist; activeIdx = i; }
        });
        container.querySelectorAll('.fast-media-thumb.is-active').forEach(function(el){ el.classList.remove('is-active'); });
        if (thumbs[activeIdx]) thumbs[activeIdx].classList.add('is-active');
        ticking = false;
      });
    }
    if (track) track.addEventListener('scroll', onScroll, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.fast-media-gallery').forEach(init);
  });
})();


